
import Hourglass from '../../../assets/svg/Hourglass';
import { ApplicationStatus } from '../../../domain/types';
import useComponentTracker from '../../../hooks/useComponentTracker';
import useTranslation from '../../../hooks/useTranslation';
import StatusPage from '../StatusPage';

const StatusInspectionPage = () => {
    useComponentTracker('StatusInspectionPage', ApplicationStatus.inspection);
    const translate = useTranslation();

    return (
        <StatusPage
            icon={<Hourglass />}
            title={translate(`page.status-inspection.title`)}
            body={translate(`page.status-inspection.description`)}
        />
    );
};

export default StatusInspectionPage;
